import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import { INSIDER_HERO_COPY, SUBSCRIBE_HERO_HEADLINE } from '../../lib/homeContent.js';
import HomeHeroLogo from './HomeHeroLogo.jsx';

export default function HomeHero() {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    const q = trimmed ? `?email=${encodeURIComponent(trimmed)}` : '';
    navigate(`/signup${q}`);
  };

  return (
    <section
      className="home-hero relative w-full bg-black text-white border-b-4 border-black overflow-hidden"
      aria-labelledby="home-hero-heading"
    >
      <div className="relative max-w-page mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_360px] gap-8 md:gap-10 md:items-center">
          <div className="text-left w-full">
            {loading ? (
              <p className="text-[13px] text-white/70 italic m-0">Loading…</p>
            ) : isAuthenticated ? (
              <>
                <h1 id="home-hero-heading" className="sr-only">
                  HangarX Daily
                </h1>
                <p className="font-sans text-[clamp(1rem,2vw,1.125rem)] leading-relaxed text-white/95 max-w-3xl m-0">
                  {INSIDER_HERO_COPY}
                </p>
                <Link to="/today" className="home-hero-cta">
                  Read today&apos;s brief
                </Link>
              </>
            ) : (
              <>
                <h1
                  id="home-hero-heading"
                  className="font-sans text-[clamp(1.25rem,3vw,1.75rem)] font-bold leading-snug tracking-tight m-0 max-w-2xl"
                >
                  {SUBSCRIBE_HERO_HEADLINE}
                </h1>
                <p className="mt-3 text-[14px] leading-relaxed text-white/80 max-w-lg m-0">
                  Editor-curated eVTOL, defense aviation, and AAM intelligence — weekday mornings.
                </p>

                <form
                  onSubmit={onSubmit}
                  className="mt-6 flex flex-col sm:flex-row sm:items-stretch gap-2 max-w-md w-full"
                  noValidate
                >
                  <label htmlFor="home-hero-email" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="home-hero-email"
                    type="email"
                    autoComplete="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="flex-1 min-w-0 rounded-md border-0 px-3 py-2.5 text-[14px] text-[#0A0A0A] placeholder:text-[#737373] focus:outline-none focus:ring-2 focus:ring-hxd-orange"
                  />
                  <button
                    type="submit"
                    className="shrink-0 rounded-md bg-hxd-orange px-6 py-2.5 text-[12px] font-bold tracking-[0.08em] uppercase text-white transition-opacity hover:opacity-90 sm:w-auto w-full"
                  >
                    Subscribe
                  </button>
                </form>

                <p className="mt-3 text-[10px] leading-snug text-white/55 max-w-md m-0">
                  By subscribing, you accept our{' '}
                  <Link to="/signup" className="underline hover:text-white/90">
                    account terms
                  </Link>
                  . Unsubscribe anytime.
                </p>
              </>
            )}
          </div>

          <div className="flex justify-center md:justify-end md:items-center">
            <HomeHeroLogo />
          </div>
        </div>
      </div>
    </section>
  );
}
